<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="getAsset"
          :loading="loading"
          :total-data="totalRows"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="assetForm"
          :redirect-detail="false"
          :show-add-button="!isReadonly"
          caption="<i class='fa fa-align-justify'></i> Aset Barang Listing"
          addButton="Tambah Asset Barang"
          @editForm="editForm"
          @resetForm="resetForm"
        ></global-table>

        <b-modal
          ref="myModalRef"
          id="addModals"
          header-border-variant="no-border text-center"
          footer-border-variant="no-border"
          footer-bg-variant="light"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          hide-footer
          size="xl"
        >
          <div slot="modal-header" class="text-center">
            <h3 class="text-center" v-if="!isEdit">Input Asset Baru</h3>
            <h3 class="text-center" v-else-if="isEdit">Ubah Asset</h3>
          </div>

          <b-form id="assetOwnerForm" validated novalidate v-on:submit.prevent="saveProcess">
            <div v-if="!loadingSubmitModal">
              <b-row>
                <b-col sm="4">
                  <b-row>
                    <b-col sm="12">
                      <b-form-group label-for="asset_owner_id" label="Nama Barang">
                        <model-select
                          id="asset_owner_id"
                          :options="listAssetOwner"
                          v-model="$v.assetForm.asset_owner_id.$model"
                          :isError="$v.assetForm.asset_owner_id.$invalid"
                          placeholder="-- Harap pilih salah satu --"
                        ></model-select>
                        <div
                          v-if="assetForm.asset_owner_id === null"
                          class="invalid-feedback-custom"
                        >Nama Barang harus di isi.</div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12">
                      <b-form-group label-for="status" label="Status Barang">
                        <model-select
                          id="status"
                          :options="listAssetStatus"
                          v-model="$v.assetForm.status.$model"
                          :isError="$v.assetForm.status.$invalid"
                          placeholder="-- Harap pilih salah satu --"
                        ></model-select>
                        <div
                          v-if="assetForm.status === null"
                          class="invalid-feedback-custom"
                        >Status Barang harus di isi.</div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12">
                      <b-form-group label-for="serial_number" label="Serial Number">
                        <b-form-input
                          id="serial_number"
                          type="text"
                          v-model="$v.assetForm.serial_number.$model"
                          :state="!$v.assetForm.serial_number.$invalid"
                          required
                          placeholder="Serial Number"
                        ></b-form-input>
                        <b-form-invalid-feedback>Serial number harus di isi.</b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12" v-if="validationForm===true || assetForm.file === null">
                      <b-form-group label-for="file" label="Foto Asset">
                        <b-form-file
                          ref="inputDocument"
                          accept="image/*"
                          @change="OnFileSelected($event)"
                          v-model="assetForm.file"
                        ></b-form-file>
                        <!-- <div
                          v-if="assetForm.file === null || assetForm.file === undefined"
                          class="invalid-feedback-custom"
                        >Dokumen harus di isi.</div> -->
                      </b-form-group>
                    </b-col>
                    <b-col sm="12" v-else-if="validationForm===false || assetForm.file !== null">
                      <b-button
                        size="sm"
                        v-on:click.prevent="changeImage($event.target)"
                        variant="stack-overflow"
                        class="mr-1 btn-brand float-right"
                      >
                        <i class="fa fa-minus"></i>
                        <span>Change Image</span>
                      </b-button>
                      <b-img v-if="assetForm.file !== null" :src="imgpath+'assets/'+assetForm.file" fluid></b-img>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12">
                      <b-form-group label-for="description" label="Deskripsi">
                        <b-form-textarea
                          id="description"
                          :rows="3"
                          :max-rows="6"
                          v-model="$v.assetForm.description.$model"
                          :state="!$v.assetForm.description.$invalid"
                        ></b-form-textarea>
                        <b-form-invalid-feedback>Deskripsi harus di isi.</b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>

                    <b-col sm="12">
                      <b-form-group label-for="image_information" label="Image Information">
                        <b-form-input
                          id="image_information"
                          type="text"
                          v-model="$v.assetForm.image_information.$model"
                          :state="!$v.assetForm.image_information.$invalid"
                          placeholder="Image Information"
                        ></b-form-input>
                        <b-form-invalid-feedback>Image Information harus di isi.</b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col sm="8">
                  <div v-if="!loadingRelatedCustomer">
                    <global-table
                      :table-data="relatedCustomer"
                      :loading="loading"
                      :per-page="10"
                      :bordered="true"
                      :table-detail="tableDetail2"
                      :hover="true"
                      :striped="false"
                      :fields="fields_related_customer_asset"
                      :redirect-detail="false"
                      :show-add-button="false"
                      caption="<i class='fa fa-align-justify'></i> Aset Barang Listing"
                      addButton="Tambah Asset Barang"
                    ></global-table>
                  </div>
                  <div v-else>
                    <loading></loading>
                  </div>
                </b-col>
              </b-row>
              
              <div class="float-right">
                <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
                  <i class="fa fa-undo"></i> Back
                </b-button>&nbsp;
                <b-button
                  v-if="!isReadonly"
                  type="submit"
                  size="sm"
                  variant="primary"
                  :disabled="$v.assetForm.$invalid"
                >
                  <i class="fa fa-save"></i> Save
                </b-button>
              </div>
            </div>
            <div v-else>
              <loading></loading>
            </div>
          </b-form>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/TableNew.vue";
import masterInterfaces from "@/templates/_master_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect } from "vue-search-select";
import custom_validation from "@/templates/_customValidation.js";
import _accessApi from "@/router/_accessApi.js";
import loading from "@/templates/Loading.vue";

export default {
  name: "asset_all",
  components: { globalTable, ModelSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    },
    tableDetail2: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      asset: [],
      relatedCustomer: [],
      listAssetOwner: [],
      listAssetStatus: [],
      loading: true,
      loadingSubmitModal: false,
      loadingRelatedCustomer: false,
      validationForm: true,
      prevFileAsset: null,
      totalRows: "",
      imgpath:
        location.host === "localhost:8080"
          ? _accessApi.localhost.upload_path
          : _accessApi.server.upload_path,
      fields: [
        { key: "owner_name", label: "Nama Barang", sortable: true },
        { key: "serial_number", label: "Serial Number", sortable: true },
        { key: "description", label: "Deskripsi" },
        { key: "inserted_time", label: "Inserted Date", sortable: true},
        { key: "status_name", label: "Status", sortable: true},
        { key: "action", class: "text-center width-80" }
      ],
      fields_related_customer_asset: [
        { key: "customer_name_history_asset", label: "Nama Konsumen", sortable: true },
        { key: "periode_placement_date", label: "Periode Penempatan"},
        { key: "status_asset_assign_now_name", label: "Status Sblm Penempatan" },
        { key: "status_asset_return_now_name", label: "Status Stlh Kembali" }
      ],
      assetForm: masterInterfaces.asset,
      isEdit: false
    };
  },
  validations() {
    if (this.validationForm) {
      return custom_validation.assets.add;
    } else {
      return custom_validation.assets.edit;
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  computed: {
    isReadonly() {
      let employee_id = localStorage.getItem("nik");
      return localStorage.getItem("level") === "1" ||
        localStorage.getItem("level") === "2" || [ 'MBS22090004'].includes(employee_id)
        ? false
        : true;
    }
  },
  methods: {
    getAsset: function(ctx) {
      this.loading = true;
      let response = axios.post("web/master/assets/all/", ctx);
        return response.then((data) => {
          const items = data.data.data;
          this.totalRows = data.data.total_rows;
          this.loading = false;
          return(items)
        })
        .catch(error => {
        this.expired(error);
        this.loading=false;
        return []
      })
    },

    init: function() {
      this.getDropdown();
      this.getAssetStatus();
      
    },
    
    getAssetStatus: function() {
      this.axios
        .get("web/dropdown/asset-status/")
        .then(response => {
          this.listAssetStatus = response.data.data;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdown: function() {
      this.axios
        .get("web/dropdown/asset-owner/")
        .then(response => {
          this.listAssetOwner = response.data.data;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    editForm: function(e) {
      this.isEdit = true;
      this.relatedCustomer = [];
      if (e.file === "") {
        this.validationForm = true;
        this.prevFileAsset = null;
      } else {
        this.validationForm = false;
        this.prevFileAsset = e.file;
      }
      this.assetForm = e;
      this.loadingRelatedCustomer = true;

      this.axios
        .get("web/master/assets/all-related-customer/" + this.assetForm.id + "/")
        .then(response => {
          this.relatedCustomer = response.data.data;
        })
        .catch(error => {
          this.expired(error, "Retrieve Related Customer");
        })
        .finally(() => {
          this.loadingRelatedCustomer = false;
        });
      // console.log(e.id);
    },
    resetForm: function() {
      this.relatedCustomer = [];
      for (var a in masterInterfaces.asset) {
        masterInterfaces.asset[a] = null;
      }
      this.assetForm = masterInterfaces.asset;
    },
    cancelAdd: function() {
      this.isEdit = false;
      this.$refs.myModalRef.hide();
      // if (this.validationForm === true) {
      //   this.$refs.inputDocument.reset();
      // }
      this.validationForm = true;
    },
    OnFileSelected: function(event) {
      this.assetForm.file = event.target.files[0];
    },
    changeImage: function(event) {
      if (confirm("Apakah anda ingin mengganti foto ini?")) {
        this.validationForm = true;
        this.assetForm.file = null;
      }
    },
    saveProcess: function(evt) {
      evt.preventDefault();
      if (this.isEdit) {
        if (confirm("Apakah anda ingin mengubah asset ini?")) {
          this.loadingSubmitModal = true;
          let formData = new FormData();
          formData.append("id", this.assetForm.id);
          formData.append("asset_owner_id", this.assetForm.asset_owner_id);
          formData.append("serial_number", this.assetForm.serial_number);
          formData.append("file", this.assetForm.file);
          formData.append("prevFile", this.prevFileAsset);
          formData.append("description", this.assetForm.description);
          formData.append("status", this.assetForm.status);
          formData.append("image_information", this.assetForm.image_information);
          formData.append("updated_by", localStorage.getItem("employee_id"));

          this.axios
            .post("web/master/assets/edit/", formData, {
              headers: { "Content-Type": "multipart/form-data" }
            })
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Ubah Asset Berhasil",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
              this.expired(error, "Ubah asset");
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      } else {
        if (confirm("Apakah anda ingin menambahkan asset ini?")) {
          this.loadingSubmitModal = true;
          let formData = new FormData();
          formData.append("asset_owner_id", this.assetForm.asset_owner_id);
          formData.append("serial_number", this.assetForm.serial_number);
          formData.append("file", this.assetForm.file);
          formData.append("description", this.assetForm.description);
          formData.append("status", this.assetForm.status);
          formData.append("image_information", this.assetForm.image_information);
          formData.append("inserted_by", localStorage.getItem("employee_id"));

          this.axios
            .post("web/master/assets/add/", formData, {
              headers: { "Content-Type": "multipart/form-data" }
            })
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Tambah Asset Berhasil",
                  message: response.data.message
                });
              } else {
                this.showErrorNotification({
                  title: "Tambah Asset Gagal",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
              this.expired(error, "Tambah asset");
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      }
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

  